import Container from './StashHeader.container';
import StashHeader from './StashHeader';

export default Container(StashHeader);
